import { render } from "./HeroiconsOutlinePhone.vue?vue&type=template&id=c114e88c"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePhone.vue"]])

export default __exports__